// environment
export const APP_ENV =  process.env.REACT_APP_ENV;
export const API_BASE_URL = process.env.REACT_APP_INSIGHT_API_URL;
export const API_PAYROLL_BASE_URL = process.env.REACT_APP_PAYROLL_BASE_URL;
export const API_ANALYTIC_BASE_URL= process.env.REACT_APP_ANALYTIC_API_URL;
export const API_ATTENDANCE_METRICS_BASE_URL = process.env.REACT_APP_ATT_METRICS_BASE_URL
export const TALENTA_BASE_URL = process.env.REACT_APP_TALENTA_BASE_URL;
export const AVATAR_BASE_URL = process.env.REACT_APP_AVATAR_BASE_URL;
export const API_TOKEN = process.env.REACT_APP_TOKEN;
export const API_TOKEN_ATTENDANCE = process.env.REACT_APP_TOKEN_ATTENDANCE;
export const API_SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
export const API_V_KEY = process.env.REACT_APP_V_KEY;
export const API_X_KEY = process.env.REACT_APP_X_KEY;
export const SSO_BASE_URL = process.env.REACT_APP_SSO_BASE_URL;
export const SSO_SIGNOUT_PARAM = process.env.REACT_APP_SSO_SIGNOUT_PARAM;
export const SSO_SCOPE = process.env.REACT_APP_SSO_SCOPE;
export const INSIGHT_BASE_URL = process.env.REACT_APP_INSIGHT_BASE_URL;
export const SSO_CLIENT_ID = process.env.REACT_APP_SSO_CLIENT_ID;
export const TALENTA_ATTENDANCE_URL = process.env.REACT_APP_TALENTA_ATTENDANCE_URL;
export const GA_ID = process.env.REACT_APP_GA_ID;
export const INSIGHT_PLUS_BASE_URL = process.env.REACT_APP_INSIGHT_PLUS_BASE_URL;
export const IFRAME_SECRET_KEY = process.env.REACT_APP_IFRAME_SECRET_KEY;
export const IFRAME_IV_KEY = process.env.REACT_APP_IFRAME_IV_KEY;
export const LOU_ENABLED = process.env.REACT_APP_LOU_ENABLED;
export const ALI_TOGGLE = process.env.REACT_APP_ALI_TOGGLE;

// headcount
export const API_NEW_JOINER = `/headcounts/new_joiner`;
export const API_HEADCOUNT_TREND = `/headcounts/trends`;
export const API_TURNOVER_RATE = `/headcounts/turnover_rate`;
export const API_LEAVING = `/headcounts/leaving`;
export const API_HEADCOUNT_ORGANIZAATION = `/headcounts/organizations`;
export const API_HEADCOUNT_JOBLEVEL = `/headcounts/job_level`;
export const API_HEADCOUNT_SERVICE_LENGTH = `/headcounts/tenure`;
export const API_HEADCOUNT_REACHING_TENURE = `/headcounts/reaching_tenure`;
export const API_HEADCOUNT_RESIGN_JOIN = `/headcounts/resign_join`;
export const API_HEADCOUNT_HR_RATIO = `/headcounts/hr_ratio`;
export const API_TURNOVER_BY_GENDER = `/headcounts/turnover_by_gender`;
export const API_TURNOVER_BY_EDUCATION = `/headcounts/turnover_by_education`;
export const API_TURNOVER_BY_AGE = `/headcounts/turnover_by_age`;
export const API_TURNOVER_BY_VOLUNTARY = `/headcounts/turnover_by_voluntary`;
export const API_TURNOVER_BY_WORKS_PERIOD = `/headcounts/turnover_by_works_period`;
export const API_HEADCOUNT_RESIGN_REASON = `/headcounts/resign_reason`;
export const API_HEADCOUNT_REPRIMAND_TYPES = `/headcounts/reprimand_types`;
export const API_HEADCOUNT_REPRIMAND_HISTORY = `/headcounts/reprimand_history`;
export const API_HEADCOUNT_BREAKDOWN = `/headcounts/breakdown/{{type}}`;
export const API_HEADCOUNT_EMPLOYEE_TRANSFER = `/headcounts/employee_transfer`;
// attendance
export const API_ATTENDANCE_RECORDS = `/attendances/attendance_records`;
export const API_EMPLOYEE_ATTENDANCE_RECORDS = `/attendances/monthly_late_users`;
export const API_EMPLOYEE_ATTENDANCE_MODAL_RECORDS = `/attendances/monthly_late_by_user`;
export const API_ATTENDANCE_TIMEOFF_POLICIES = `/attendances/timeoff_policies`;
export const API_ATTENDANCE_TIMEOFF = `/attendances/monthly_timeoff_users`;
export const API_ATTENDANCE_TIMEOFF_TRENDS = `/attendances/timeoff_trends`;
export const API_ATTENDANCE_METRICS = `/public_api/attendance/`;
export const API_ATTENDANCE_SUMMARY_METRICS = `/attendances/summary_metrics`;
export const API_ATTENDANCE_SUMMARY_METRICS_AGG = `/attendances/summary_metrics_agg`;
export const API_ATTENDANCE_LAST_UPDATE = `/attendances/last_update_time`;
export const API_ATTENDANCE_TIMEOFF_BY_USER = `/attendances/monthly_timeoff_by_user`;
// survey
export const API_ATTENDANCE_ORGANIZATION = `api/v1/company/organizations`;
export const API_ATTENDANCE_BRANCHES = `api/v1/company/branches`;
export const API_SHOW_SURVEY = `/v1/survey/showable`;
export const API_CLOSE_SURVEY = `/v1/survey/close`;
export const API_JOB_POSITION = `/api/v1/company/job_positions`;
// Attritions
export const API_ATTRITIONS_OVERVIEW = `/attritions/overview`;
export const API_ATTRITIONS_OVERVIEW_BY_FILTER = `/attritions/overview_by_{{FILTER}}`;
// Global
export const API_LAST_UPDATE = `/{{type}}/last_update_time`;
export const API_BRANCHES_FILTER = `/companies/branches`;
export const API_ORGANIZATIONS_FILTER = `/companies/organizations`;
export const API_JOBS_FILTER = `/companies/job_positions`;
export const API_CNAME = `/companies/cname`;
// SSO-CALLBACK AUTH
export const API_GENERATE_TOKEN = `/auth/token`;
export const API_REFRESH_TOKEN = `/auth/refresh_token`;
export const API_CHECK_AUTH = `/check_auth`;
export const API_CURRENT_USER = `/auth/current_user`;
export const API_SET_CURRENT_COMPANY = `/auth/set_current_company`;
export const API_SIGN_OUT = `/auth/sign_out`;
export const API_REDIRECT = `/check_redirect`;
// Tracker
export const API_DASHBOARD_TRACKER = '/dashboards/tracker';
export const API_DASHBOARD_FILTER_TRACKER = '/dashboards/filter_tracker';
export const API_TIMEOFF_TREND_TRACKER = '/attendances/timeoff_filter_tracker';
export const API_LOAD_TIME_DASHBOARD = '/dashboards/chart_tracker';
export const API_EXPORT_TRACKER = '/dashboards/export_tracker';
export const API_LOU_TRACKER = '/dashboards/lou_tracker';
// quicksight
export const API_EMBED_URL_EMPLOYEE_PERFORMANCE = '/dashboards/embed_performance_url';
export const API_EMBED_URL_OVERTIME = '/dashboards/embed_overtime_url';
export const API_EMBED_CUSTOM_DASHBOARD = '/dashboards/embed_custom_url';
export const API_EXPORT_METABASE_CUSTOM_DASHBOARD = '/dashboards/export_metabase';
export const API_EMBED_TABS = '/dashboards/tabs';
export const API_REMOVE_EMBED_SESSION = '/dashboards/remove_embed_session';
// export history
export const API_EXPORT_HISTORY = '/exports/download_list';
export const API_EXPORT_DOWNLOAD = '/exports/download_file';
// toggle
export const API_FEATURE_TOGGLE = '/feature_toggles'